import { jsx as _jsx } from "react/jsx-runtime";
import { icons } from './icons.js';
/** The icon scale, in px. */
export const iconSizes = [12, 14, 16, 18, 20, 24, 32];
/** The one stroke weight of every icon. */
export const ICON_STROKE_WIDTH = 2;
export function Icon({ name, size = 16, label, ...props }) {
    const Glyph = icons[name];
    return (_jsx(Glyph, { "data-icon": name, size: size, strokeWidth: ICON_STROKE_WIDTH, focusable: "false", ...(label === undefined ? { 'aria-hidden': true } : { role: 'img', 'aria-label': label }), ...props }));
}
//# sourceMappingURL=icon.js.map